module.exports = __webpack_public_path__ + "static/media/599.768.1656638a.pdf";